import React, { useEffect, useState } from 'react';

import { useTheme } from 'styled-components';

import { FaFileExcel } from 'react-icons/fa';
import { FaFilePdf } from 'react-icons/fa';
import { FiPackage } from 'react-icons/fi';

import { useHistory, useLocation } from 'react-router-dom';

import api from '~/services/api';

import { exportCsv } from '~/helpers/csv';
import { exportPdf } from '~/helpers/pdf';

import {
  Scroll,
  Container,
  Header,
  Area,
  Grid,
  GridLine,
  GridHeadItem,
  GridItem,
  Progress,
  Loading,
  Empty,
  Summary,
} from '~/components';

import { Align, ClearFiltersBtn, LoadArea, Reflection, Thumb } from './styles';

import ProdutoType from '~/@types/produto';
import { IoMdClose } from 'react-icons/io';

const Produtos: React.FC = () => {
  const history = useHistory();
  const { colors } = useTheme();

  const useQuery = () => {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  };

  let query = useQuery();

  const [inLoad, setInLoad] = useState(false);
  const [isPristine, setIsPristine] = useState(true);
  const [busca, setBusca] = useState('');

  const [produtos, setProdutos] = useState<ProdutoType[]>([]);

  const fetchProdutos = async (pStrSearch: string) => {
    try {
      setIsPristine(false);
      setInLoad(true);
      setProdutos([]);

      const response = await api.get(`produtos?busca=${pStrSearch}`);

      const { data } = response;

      if (data && data.length) {
        setProdutos(data);
      }

      setInLoad(false);
    } catch (e) {
      setInLoad(false);
    }
  };

  const gerarRelatorioCSV = () => {
    let data: string[] = [];

    data.push('IDPRODUTO,SKU;NOME;PRECO;ESTOQUE');

    let c;
    for (c in produtos) {
      const produto = produtos[c];
      let v;
      for (v in produto.variacoes) {
        const variacao = produto.variacoes[v];
        data.push(
          `${produto.idproduto};${variacao.sku};${produto.nome} ${variacao.descricao};${produto.preco};${variacao.estoque}`,
        );
      }
    }

    const csv = data.join('\n');

    exportCsv(csv, 'PRODUTOS');
  };

  const gerarRelatorioPDF = () => {
    const cabecalho = ['IDPRODUTO', 'SKU', 'NOME', 'PREÇO', 'ESTOQUE'];

    const data: string[][] = [];

    let c;
    for (c in produtos) {
      const produto = produtos[c];

      let v;
      for (v in produto.variacoes) {
        const linha: string[] = [];
        const variacao = produto.variacoes[v];
        linha.push(produto.idproduto);
        linha.push(variacao.sku);
        linha.push(`${produto.nome} ${variacao.descricao}`);
        linha.push(produto.precoformatado);
        linha.push(variacao.estoque);
        data.push(linha);
      }
    }

    exportPdf(cabecalho, data, 'PRODUTOS');
  };

  const resetar = () => {
    query.delete('busca');
    history.push({
      pathname: '/produtos',
      search: `?${query.toString()}`,
    });
  };

  const buscarProdutos = async (pStrSearch: string) => {
    if (pStrSearch && pStrSearch !== '') {
      query.set('busca', pStrSearch);
    } else {
      query.delete('busca');
    }
    history.push({
      pathname: '/produtos',
      search: `?${query.toString()}`,
    });
  };

  const exibirReflexao = () => {
    if (query.get('busca')) {
      return true;
    }
    return false;
  };

  const verificarReflexao = (pNome: string) => {
    if (query.get(pNome)) {
      return true;
    }
    return false;
  };

  const removerReflexao = (pNome: string) => {
    query.delete(pNome);
    history.push({
      pathname: '/produtos',
      search: `?${query.toString()}`,
    });
  };

  useEffect(() => {
    const sBusca = query.get('busca') || '';
    setBusca(sBusca);

    setIsPristine(true);
    setProdutos([]);

    if (sBusca && sBusca !== '') {
      fetchProdutos(sBusca);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  return (
    <>
      {inLoad ? <Progress /> : null}

      <Scroll>
        <Container>
          <Header
            title="Produtos"
            subtitle="Visualize seus produtos de forma rápida"
            isSearch
            onSearch={buscarProdutos}
            placeholder="Buscar em produtos..."
            icon={
              <>
                <FiPackage size={32} color={colors.IC1} />
              </>
            }
          />

          {produtos.length ? (
            <Summary>
              <h1>
                {produtos.length > 1
                  ? `${produtos.length} produtos encontrados`
                  : 'Um produtos encontrado'}
              </h1>
              <div>
                <button
                  className="excel"
                  onClick={gerarRelatorioCSV}
                  title="Exportar para Excel"
                >
                  <FaFileExcel size={22} color={colors.IC2} />
                  <div>
                    <h3>EXPORTAR</h3>
                    <h2>EXCEL</h2>
                  </div>
                </button>
                <button
                  className="pdf"
                  onClick={gerarRelatorioPDF}
                  title="Exportar para PDF"
                >
                  <FaFilePdf size={22} color={colors.IC2} />
                  <div>
                    <h3>EXPORTAR</h3>
                    <h2>PDF</h2>
                  </div>
                </button>
              </div>
            </Summary>
          ) : null}

          {exibirReflexao() ? (
            <Reflection>
              <h1>Filtros ativos:</h1>
              <main>
                {verificarReflexao('busca') ? (
                  <div>
                    <button onClick={() => removerReflexao('busca')}>
                      <IoMdClose size={26} color={colors.IC1} />
                    </button>
                    <span>
                      <strong>BUSCA POR:</strong>
                      <small>{busca}</small>
                    </span>
                  </div>
                ) : null}
              </main>
              <ClearFiltersBtn onClick={resetar}>
                LIMPAR TODOS OS FILTROS
              </ClearFiltersBtn>
            </Reflection>
          ) : null}

          {!inLoad ? (
            <Area>
              {produtos.length ? (
                <Grid>
                  <GridLine>
                    <GridHeadItem title="" width={80} />
                    <GridHeadItem title="ID" width={80} />
                    <GridHeadItem title="SKU" width={200} />
                    <GridHeadItem title="Nome" />
                    <GridHeadItem title="Preço" width={160} />
                    <GridHeadItem title="Estoque" width={100} />
                  </GridLine>

                  {produtos.map((produto, key) => {
                    return produto.variacoes.map(variacao => (
                      <GridLine key={produto.idproduto}>
                        <GridItem width={80}>
                          <Thumb>
                            <img
                              src={
                                produto.fotoprincipal
                                  ? produto.fotoprincipal
                                  : `https://dummyimage.com/80x80/fff/000&text=${variacao.sku}`
                              }
                              title={variacao.sku}
                              alt={variacao.sku}
                            />
                          </Thumb>
                        </GridItem>

                        <GridItem width={80}>
                          <Align>
                            <strong>{produto.idproduto}</strong>
                          </Align>
                        </GridItem>
                        <GridItem width={200}>
                          <Align>
                            <strong>{variacao.sku}</strong>
                          </Align>
                        </GridItem>
                        <GridItem>
                          <Align>
                            {produto.nome} {variacao.descricao}
                          </Align>
                        </GridItem>
                        <GridItem width={160}>
                          <Align>{produto.precoformatado}</Align>
                        </GridItem>
                        <GridItem width={100}>
                          <Align>{variacao.estoque}</Align>
                        </GridItem>
                      </GridLine>
                    ));
                  })}
                </Grid>
              ) : (
                <>
                  {isPristine ? (
                    <Empty>Faça uma busca para encontrar o produto!</Empty>
                  ) : (
                    <Empty>Nenhum produto encontrado.</Empty>
                  )}
                </>
              )}
            </Area>
          ) : (
            <LoadArea>
              <Loading color={colors.IC1} size={42} />
            </LoadArea>
          )}
        </Container>
      </Scroll>
    </>
  );
};

export default Produtos;
